module.exports = "icons/phone.svg";